module.exports = __webpack_public_path__ + "img/2728.fe1ddb3b.jpg";